import api from './client'

export const enrichApi = {
  enrichOne: (prospectId) =>
    api.post(`/api/enrichment/${prospectId}`),

  enrichBulk: (prospectIds) =>
    api.post('/api/enrichment/bulk', { prospect_ids: prospectIds }),

  scrapeOne: (prospectId) =>
    api.post(`/api/enrichment/scrape/${prospectId}`),

  scrapeBulk: (prospectIds) =>
    api.post('/api/enrichment/scrape/bulk', { prospect_ids: prospectIds }),

  scrapeAll: () =>
    api.post('/api/enrichment/scrape/all'),

  scrapeStatus: () =>
    api.get('/api/enrichment/scrape/status'),

  verifyBulk: (prospectIds) =>
    api.post('/api/enrichment/verify/bulk', { prospect_ids: prospectIds }),

  outscraperVerifyBulk: (prospectIds) =>
    api.post('/api/enrichment/outscraper-verify/bulk', { prospect_ids: prospectIds }),

  outscraperVerifyAll: () =>
    api.post('/api/enrichment/outscraper-verify/all'),

  outscraperPhoneBulk: (prospectIds) =>
    api.post('/api/enrichment/outscraper-phone/bulk', { prospect_ids: prospectIds }),
}